// RevisionView.tsx
import React from 'react';

interface ICasino {
  hasRibbon: boolean;
  ribbonText: string;
  ribbonType: string;
  position: number;
  image: string;
  imageAlt?: string;
  bonus: string;
  term1?: string;
  term2?: string;
  term3?: string;
  termsPlain: string;
  termsLinks: string[];
  gotoLink: string;
  trackingLink?: string;
  firebaseImageUrl?: string;
  mainTermsText?: string;
}

interface ICasinoWithId extends ICasino {
  id: string;
  deleted: boolean;
}

interface RevisionData {
  parentData: { [key: string]: any };
  casinosData: ICasinoWithId[];
}

interface RevisionViewProps {
  revision: RevisionData;
  onClose: () => void;
}

const RevisionView: React.FC<RevisionViewProps> = ({ revision, onClose }) => {
  const { parentData, casinosData } = revision;
  const headerTexts = parentData.headerTexts || {};
  const ctaButtonText = parentData.ctaButtonText || '';
  const loadMoreButtonText = parentData.loadMoreButtonText || '';

  return (
    <div
      style={{
        background: '#fff',
        borderRadius: '8px',
        padding: '20px',
        width: '90%',
        maxWidth: '1200px',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}
    >
      <h2>Revision View (Read-Only)</h2>
      <h3>Parent Data</h3>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
        <div>
          <label>POS:</label>
          <input type="text" value={headerTexts.posText} disabled style={{ marginLeft: '5px' }} />
        </div>
        <div>
          <label>CASINO:</label>
          <input type="text" value={headerTexts.casinoText} disabled style={{ marginLeft: '5px' }} />
        </div>
        <div>
          <label>CASINO BONUS:</label>
          <input type="text" value={headerTexts.casinoBonusText} disabled style={{ marginLeft: '5px' }} />
        </div>
        <div>
          <label>MORE INFO:</label>
          <input type="text" value={headerTexts.moreInfoText} disabled style={{ marginLeft: '5px' }} />
        </div>
        <div>
          <label>MOVE ON:</label>
          <input type="text" value={headerTexts.moveOnText} disabled style={{ marginLeft: '5px' }} />
        </div>
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <label>CTA Button Text:</label>
        <input type="text" value={ctaButtonText} disabled style={{ marginLeft: '5px' }} />
      </div>
      <div style={{ marginBottom: '1rem' }}>
        <label>Load More Button Text:</label>
        <input type="text" value={loadMoreButtonText} disabled style={{ marginLeft: '5px' }} />
      </div>
      <h3>Casinos</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead style={{ position: 'sticky', top: 0, background: '#fff' }}>
          <tr style={{ background: '#f5f5f5' }}>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Ribbon?</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Ribbon Text</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Ribbon Type</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Position</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Image</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Alt Text</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Bonus</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Term 1</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Term 2</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Term 3</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Terms (Plain)</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Terms Link(s)</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Main Terms Text</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Goto Link</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Tracking Link</th>
            <th style={{ padding: '8px', border: '1px solid #ddd' }}>Deleted?</th>
          </tr>
        </thead>
        <tbody>
          {casinosData.map(casino => (
            <tr key={casino.id}>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="checkbox" checked={casino.hasRibbon} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.ribbonText} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.ribbonType} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.position} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                <img src={casino.firebaseImageUrl || casino.image} alt={casino.imageAlt || 'Casino'} style={{ maxWidth: '80px' }} />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.imageAlt || ''} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.bonus} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.term1 || ''} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.term2 || ''} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.term3 || ''} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.termsPlain} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.termsLinks.join(', ')} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.mainTermsText || ''} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.gotoLink} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                <input type="text" value={casino.trackingLink || ''} disabled />
              </td>
              <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'center' }}>
                <input type="checkbox" checked={casino.deleted} disabled />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ textAlign: 'right', marginTop: '20px' }}>
        <button
          onClick={onClose}
          style={{
            padding: '8px 12px',
            background: '#007BFF',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Close Revision View
        </button>
      </div>
    </div>
  );
};

export default RevisionView;
